// extracted by mini-css-extract-plugin
export default {"aRight":"Dashboard_aRight__Mn5Be","cPointer":"Dashboard_cPointer__oLJY7","header":"Dashboard_header__VuM8E"};